// manage.module.ts
import { NgModule, CUSTOM_ELEMENTS_SCHEMA } from "@angular/core";
import { CommonModule } from "@angular/common";
import { RouterModule, Routes } from "@angular/router";
import { ManageLayoutComponent } from "./manage-layout/manage-layout.component";
import { SharedModule } from "app/shared/shared.module";
import { SearchResultsModule } from "@rubbl-search-results";
import { AuthGuard } from "@rubbl-core";
import { LayoutModule } from "@rubbl-layout";
import { ManageResolverService } from "./manage-shared/manage-resolver.service";
import { LocationsComponent } from "./owner/owner-locations/locations.component";
import { NgxDatatableModule } from '@swimlane/ngx-datatable';
import { NgbModalModule } from '@ng-bootstrap/ng-bootstrap';
import { FormsModule } from '@angular/forms';
import { AzureMapsModule } from "@rubbl-azure-maps";  

const routes: Routes = [
  {
    path: "",
    component: ManageLayoutComponent,
    canActivate: [AuthGuard],
    resolve: {
      data: ManageResolverService,
    },
    runGuardsAndResolvers: "always",
    children: [
      {
        path: "renter",
        loadChildren: () => import("./renter/renter.module").then(m => m.RenterModule),
      },
      {
        path: "owner",
        loadChildren: () => import("./owner/owner.module").then(m => m.OwnerModule),
      },
      {
        path: "affiliate",
        loadChildren: () => import("./affiliate/affiliate.module").then(m => m.AffiliateModule),
      },
      {
        path: "account",
        loadChildren: () => import("./account/account.module").then(m => m.AccountModule),
      },
      // need this redirect to support email urls
      {
        path: "manage/rentals",
        redirectTo: "renter/rentals",
      },
      // need this redirect to support email urls
      {
        path: "manage/fulfillments",
        redirectTo: "owner/fulfillments",
      },
      // not found path
      { path: "**", redirectTo: "renter" },
    ],
  },
];

@NgModule({
  declarations: [ManageLayoutComponent],
  imports: [
    CommonModule,
    SharedModule,
    LayoutModule,
    SearchResultsModule,
    RouterModule.forChild(routes),
    NgxDatatableModule,
    NgbModalModule,
    FormsModule,
    AzureMapsModule
  ],
  schemas: [CUSTOM_ELEMENTS_SCHEMA], // Add this line
})
export class ManageModule {}